export const getChartTwfFftOptions = (
  t: (text: string) => string,
  chartData: Array<[number, number]>,
  timestamp: string,
  unit?: string,
  currentXAxisMetric?: string,
  isDarkMode?: boolean,
) => {
  if (!chartData.length) {
    return {};
  }
  const chartOptions: Highcharts.Options = {
    chart: {
      style: { fontFamily: 'Roboto, sans-serif', fontSize: '12px' },
      height: 295,
      zooming: { type: 'xy' },
      backgroundColor: 'none',
    },
    title: { text: '' },
    legend: { enabled: false },
    credits: { enabled: false },
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    plotOptions: { line: { color: 'red' }, spline: { marker: { enabled: false } } },
    series: [
      {
        type: 'spline',
        data: chartData || [],
        color: isDarkMode ? '#4A91C3' : '#1F77B4',
        lineWidth: 1,
      },
    ],
    xAxis: [
      {
        type: 'linear',
        labels: {
          style: {
            fontSize: '12px',
            color: isDarkMode ? '#797F89' : '#b6bbc7', //--inputs-default-placeholder,
          },
          formatter: function () {
            if (currentXAxisMetric === 'cpm') {
              return `${+this.value * 60}`;
            }
            return this.value.toString();
          },
        },
        lineWidth: 0,
        tickLength: 0,
      },
    ],
    yAxis: [
      {
        title: undefined,
        labels: {
          style: {
            fontSize: '12px',
            color: isDarkMode ? '#797F89' : '#b6bbc7', //--inputs-default-placeholder,
          },
        },
        gridLineColor: isDarkMode ? '#595959cc' : '#ededef',
      },
    ],
    tooltip: {
      style: {
        fontSize: '12px',
      },
      formatter: function () {
        let xValue = this.x || '';

        if (currentXAxisMetric === 'cpm') {
          xValue = `${(+xValue * 60).toFixed(2)} CPM`;
        } else if (currentXAxisMetric === 'hz') {
          xValue = `${(+xValue).toFixed(2)} Hz`;
        } else {
          xValue = `${(+xValue).toFixed(2)} ${currentXAxisMetric}`;
        }

        return `${timestamp}<br/> ${t('Frequency')}: ${xValue} ${this.y} ${unit || ''}`;
      },
    },
  };

  return chartOptions;
};
